import type { VypisyudajuSouboryUlozkaDto } from '@gov-nx/api';
import type { Optional } from '@gov-nx/core/types';

export function getFileIdFromResponseData(
	data: VypisyudajuSouboryUlozkaDto
): Optional<string> {
	return data?.soubory?.[0]?.id;
}
